import { updatePassword, UpdatePasswordError } from "@store/visitWidgetApi";
import { AppDispatch } from "@store/store";
import { logError, logInfo } from "@lib/logger";
import { authTokenSuccessAction } from "./authTokenSuccessAction";
import { setAuthViewAction } from "@store/sessionReducer";
export interface ResetPasswordActionParams {
  resetPasswordToken: string;
  newPassword: string;
}

/*
 * Request reset password
 */
const resetPasswordAction =
  ({ resetPasswordToken, newPassword }: ResetPasswordActionParams) =>
  async (dispatch: AppDispatch) => {
    try {
      const response = await updatePassword({
        resetPasswordToken,
        newPassword,
      });
      await dispatch(authTokenSuccessAction({ authToken: response.authToken }));
    } catch (error) {
      if (
        (error as UpdatePasswordError)?.errors?.invalid_token ||
        (error as UpdatePasswordError)?.errors?.expired
      ) {
        logInfo(error);
        dispatch(setAuthViewAction({ authView: "resetPasswordExpired" }));
      } else {
        logError(error);
        throw error;
      }
    }
  };

export { resetPasswordAction };
